import { type ReactNode } from 'react';

import { Content } from './styles';

export interface IContentPaginationProps {
  children: ReactNode;
  dataCy?: string;
}

export const ContentPagination = ({
  children,
  dataCy = 'content-modal',
}: IContentPaginationProps): JSX.Element => {
  return (
    <Content id="content-pagination" data-cy={dataCy}>
      {children}
    </Content>
  );
};
